var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var RowsQuery = /** @class */ (function () {
    function RowsQuery(page, perPage, sortFields, versionId) {
        this.page = page;
        this.perPage = perPage;
        this.sortFields = sortFields;
        this.versionId = versionId;
    }
    Object.defineProperty(RowsQuery.prototype, "searchParams", {
        get: function () {
            return new URLSearchParams(__spreadArray([
                ['page', String(this.page)],
                ['perPage', String(this.perPage)],
                this.versionId !== null ? ['data-version-id', String(this.versionId)] : ['', '']
            ], this.sortFields.map(function (sortField) { return ['sort', "".concat(sortField.property, ",").concat(sortField.direction)]; }), true));
        },
        enumerable: false,
        configurable: true
    });
    return RowsQuery;
}());
export { RowsQuery };
